export enum StakeModifier {
    plus = "plus",
    minus = "minus"
}

export enum PriceStatusClass {
    periodOver = "over",
    periodResulting = "resulting",
    periodCurrent = "current",
    periodPre = "not-started"
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./data/models/Modifiers/Modifiers.ts